'use strict';

export class init {
    constructor() {
        this.bindHandlers();
    }

    bindHandlers() {
        $('button#contact-us-btn').click(function () {
            let contactInput = $('#child_contact_contact');

            if (!$.trim(contactInput.val())) {
                contactInput.addClass('error');
                return false;
            }

            contactInput.removeClass('error')
            $('form#child-contact-us-form').submit();
        });

        $('form#child-contact-us-form').on('submit', function () {
            $.ajax({
                type: 'POST',
                url: $(this).attr('action'),
                data: new FormData($(this)[0]),
                contentType: false,
                processData: false,
            });

            $('#child_contact_contact').val('');
            $('#child_contact_message').val('');
            return false;
        });
    }
}